//draft

export const LANDING = '/'
export const CONTACTS = '/contacts'
